export enum Modals {
  AboutUs = 'AboutUs',
  Login = 'Login',
  Deposit = 'Deposit',
  Registration = 'Registration',
  BecomeVip = 'BecomeVip',
  Withdraw = 'Withdraw',
  Topics = 'Topics',
  Providers = 'Providers',
  Recovery = 'Recovery',
  ChooseAvatar = 'ChooseAvatar',
  TermsAndConditionsAcceptance = 'TermsAndConditionsAcceptance',
  ConfirmGoogleRegistration = 'ConfirmGoogleRegistration',
  ConfirmGoogleCountry = 'ConfirmGoogleCountry',
  CompleteProfile = 'CompleteProfile',
  LeaveDeposit = 'LeaveDeposit',
  RefBonusNotification = 'RefBonusNotification',
  NDBEmailConfirm = 'NDBEmailConfirm',
  NDBEmailVerified = 'NDBEmailVerified',
  NDBPlayForReal = 'NDBPlayForReal',
  MissionComplete = 'MissionComplete',
  ChangeWageringCurrency = 'ChangeWageringCurrency',
}

export const ModalQueryByName: Record<Modals, string> = {
  [Modals.AboutUs]: 'about-us',
  [Modals.Login]: 'login',
  [Modals.Deposit]: 'deposit',
  [Modals.Registration]: 'registration',
  [Modals.BecomeVip]: 'become-vip',
  [Modals.Withdraw]: 'withdraw',
  [Modals.Topics]: 'topics',
  [Modals.Providers]: 'providers',
  [Modals.Recovery]: 'recovery',
  [Modals.ChooseAvatar]: 'choose-avatar',
  [Modals.TermsAndConditionsAcceptance]: 'terms-and-conditions-acceptance',
  [Modals.ConfirmGoogleRegistration]: 'confirm-google-registration',
  [Modals.ConfirmGoogleCountry]: 'confirm-google-country',
  [Modals.CompleteProfile]: 'complete-profile',
  [Modals.LeaveDeposit]: 'leave-deposit',
  [Modals.RefBonusNotification]: 'ref-bonus',
  [Modals.NDBEmailConfirm]: 'ndb-email-confirm',
  [Modals.NDBEmailVerified]: 'ndb-email-verified',
  [Modals.NDBPlayForReal]: 'ndb-play-for-real',
  [Modals.MissionComplete]: 'mission-complete',
  [Modals.ChangeWageringCurrency]: 'change-wagering-currency',
};

export const NON_AUTH_MODALS_MAP: Modals[] = [
  // Modals.Registration,
  Modals.Login,
  Modals.Recovery,
];

export const AUTH_MODALS_MAP: Modals[] = [
  Modals.Deposit,
  Modals.LeaveDeposit,
  Modals.BecomeVip,
  Modals.Withdraw,
  Modals.ChooseAvatar,
  Modals.CompleteProfile,
  Modals.RefBonusNotification,
  Modals.NDBEmailConfirm,
  Modals.NDBEmailVerified,
  Modals.NDBPlayForReal,
  Modals.MissionComplete,
];

export const QUERY_VIP = 'vip';
export const MODAL_QUERY_KEY = 'modal';
export const BONUS_ID_QUERY_KEY = 'bonusId';
